import React from "react";
import LeftMenuNavSection from "../../../components/LeftMenuNavSection";
import UserSettingsSection from "../../searchPage/leftMenu/UserSettingsSection";

const AdminLeftMenu = ({ onMenuClose }) => {
  return (
    <div className="grid h-full grid-rows-[auto_1fr] overflow-hidden">
      {/* Navigation back to search */}
      <div>
        <LeftMenuNavSection
          location={{
            name: "Search",
            url: "/private/search",
            direction: "left",
          }}
        />
      </div>
      
      {/* User settings at bottom */}
      <div className="flex flex-col justify-end overflow-y-auto pt-5">
        <div className="px-2">
          <UserSettingsSection />
        </div>
      </div>
    </div>
  );
};

export default AdminLeftMenu;